module.exports = __webpack_public_path__ + "img/patty_hero_mobile.41279315.png";